import { render, staticRenderFns } from "./EmployeePFslips.vue?vue&type=template&id=153bb590"
import script from "./EmployeePFslips.vue?vue&type=script&lang=js"
export * from "./EmployeePFslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports